<p-dialog
  [modal]="true"
  header="Sitzung abgelaufen"
  [visible]="showDialog$ | async"
  [closable]="false"
  [resizable]="false"
  [ngClass]="'session-expired-dialog'"
>
  <div class="flex flex-column gap-4">
    <span>{{ sessionText }}</span>

    <span>Bitte geben Sie Ihr Passwort ein.</span>

    <div class="ui-inputtext-with-icon w-full">
      <span class="p-float-label w-full">
        <input
          id="usernameTextField"
          class="w-full"
          type="text"
          [disabled]="true"
          pInputText
          [(ngModel)]="userName"
          pInputText
        />
        <label for="usernameTextField">Benutzername</label>
      </span>
    </div>

    <div class="ui-inputtext-with-icon passwordfield w-full">
      <span class="p-float-label w-full">
        <input
          #passwordTextField
          class="w-full"
          type="password"
          pInputText
          [disabled]="loginActive$ | async"
          autofocus="autofocus"
          [(ngModel)]="password"
          (keyup.enter)="login()"
          [ngModelOptions]="{ standalone: true }"
        />
        <label for="passwordTextField">Passwort</label>
      </span>
    </div>

    <div class="flex justify-content-between align-items-center h-3rem">
      <div>
        <button
          #unlock
          pButton
          *ngIf="!(loginActive$ | async)"
          class="login"
          label="Entsperren"
          (click)="login()"
        ></button>
        <p-progressSpinner *ngIf="loginActive$ | async" strokeWidth="3" [style]="{ width: '2.5rem', height: '2.5rem' }">
        </p-progressSpinner>
      </div>
      <i *ngIf="!(loginActive$ | async)" class="logout-button pi pi-sign-out" (click)="logout()" pTooltip="Logout"></i>
    </div>
  </div>
</p-dialog>
